import { createSlice } from '@reduxjs/toolkit'

export const authSlice = createSlice({
    name: 'auth',
    initialState: { 
        token       : ''
        ,user       : false
        ,notif      : 0
        ,fetching   : true
    }
    ,reducers : {
        setUser : (state, action) => {
            console.log('Set User Reducer auth called', action);

            localStorage.setItem('crowdbees', action.payload);
            
            state.token = action.payload;
        }
        ,setTokenizeUser : (state, action) => {

            console.log('Set Tokenized User Reducer auth called', action.payload);

            state.user = action.payload;

        }
        ,setLookingUser : (state, action) => {
            console.log('Set Loading User Reducer auth called', action.payload);

            state.fetching = action.payload;
        }
        ,setUserNotif : (state, action) => {
            console.log('Set Current User Unglanced Count', action.payload);
            state.notif = action.payload
        }
    }
});

export default authSlice.reducer;